const axios = require('axios').default;
const qs = require('qs');
class Request {
    //axios请求
    postRequest(strUrl, fun, data) {
        //qs模块转义数据格式
        data = qs.stringify(data);
        //发送post请求
        axios.post(strUrl, data).then(function (result) {
            fun(result.data);
        })
    }
}
let request = new Request();
export default request